import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getTokenId(x, y) {
  const paddedX = x + 210;
  const paddedY = y + 210;
  return paddedX * (210 * 2 + 1) + paddedY;
}
